<template>
  <div v-if="layoutComponent">
    <component :is="layoutComponent" v-bind="(fields?.data as any)?.datasource" />
  </div>
  <FormStepInputs
    v-else
    :step="{
      stepName: (fields?.data as any)?.datasource?.name,
      formInputs: (fields?.data as any)?.datasource?.content,
    }"
  />
</template>
<script setup lang="ts">
import { FormProps } from '@/interfaces';
import { INameValue } from '@/interfaces/entities/name-value.interface';
import { defineAsyncComponent } from 'vue';
import FormStepInputs from '../FormStepInputs/FormStepInputs.vue';

const props = defineProps<FormProps>();
const vuePagePath = (props.fields?.data as any)?.datasource?.fields?.find(
  (field: INameValue) => field.name == 'vuePagePath'
)?.value;
const vuePageName = (props.fields?.data as any)?.datasource?.fields?.find(
  (field: INameValue) => field.name == 'vuePageName'
)?.value;
const layoutComponent =
  vuePagePath && vuePageName ? defineAsyncComponent(() => import(`@/pages/${vuePagePath}/${vuePageName}.vue`)) : null;
</script>
